<template>
  <VList ref="list" :data="items" :style="{ height: height }" #default="item">
    <slot v-bind="item" />
  </VList>
</template>

<script setup>
import { ref } from "vue";
import { VList } from "virtua/vue";

const list = ref(null);

defineProps({
  items: { type: Array, default: () => [] },
  height: { type: String, default: "100%" },
});

defineExpose({
  scrollToIndex: (index, { align = "start", smooth = true } = {}) => {
    if (index !== -1) {
      list.value.scrollToIndex(index, { align, smooth });
    }
  },
});
</script>
